// extracted by mini-css-extract-plugin
export default {"MyDi":"accordion_MyDi__97wj0","maindivv":"accordion_maindivv__LUjtI"};